const WiFiIcon = ({className, pathClassName})=>
<svg className={className}
     viewBox="0 0 1400 987">
 <path className={pathClassName} d="M871.2 822 703.7 987 535 817.8c84.7-92.4 232.7-93.7 336.1 4.3Zm185.6-170-111 113.5C876.7 700.2 796 662.7 700.5 663c-94-.3-175 34.1-244.2 101.6L349.4 646.3C515 462.8 853.8 438 1056.8 652ZM1222 471.2l-112 112.3C995 474 860 412.4 700 412.6c-158.7-.3-293.4 59.7-408 169.4L183.5 465.4C447.2 180 947.2 175.6 1222 471.2ZM104 402.6 0 295.6C339-85.8 1027.1-110.7 1400 294l-106.4 107.5c-393-324.8-788.8-325.9-1189.6 1Z"/>
</svg>

export default WiFiIcon